<div class="d-inline-block position-relative">
  <span
    class="signature-pad-placeholder"
    *ngIf="options.placeholder && isEmpty"
    >{{ options.placeholder }}</span
  >
  <button
    *ngIf="!readonly"
    luiCab
    type="button"
    (click)="clear()"
    class="position-absolute top-1 end-1"
    iconPosition="end"
  >
    <mat-icon svgIcon="close"></mat-icon>
    Clear</button
  >
  <canvas #canvas class="signature-pad-canvas"></canvas
></div>
